import {
  AlertTriangle as AlertTriangleIcon,
  Check as CheckIcon,
  Clock as ClockIcon,
  Eye as EyeIcon,
  User as UserIcon,
} from 'react-feather'
import { colors } from '@material-ui/core'
import theme from 'theme'

const PENDING_STATUS_ID = 'pending'
const OVERDUE_STATUS_ID = 'overdue'
const COMPLETED_STATUS_ID = 'completed'
const ARCHIVED_STATUS_ID = 'archived'
const INACTIVE_STATUS_ID = 'inactive'
const SOFT_DELETED_STATUS_ID = 'soft_deleted'
const NOT_APPLICABLE_VALUE = 'not_applicable'

const OBSERVER_ROLE = 'observer'
const MANAGER_ROLE = 'manager'
const PROJECT_RESPONSIBLE_ROLE = 'project_responsible'
const AREA_RESPONSIBLE_ROLE = 'area_responsible'
const ACTIVITY_RESPONSIBLE_ROLE = 'activity_responsible'
const PLAN_ACTION_RESPONSIBLE_ROLE = 'plan_action_responsible'

const EVIDENCE_FILE_TYPES = '.pdf'
const EVIDENCE_FILE_MIMES_TYPES = ['application/pdf']

const CREATE_PROJECT_DATE_FIELDS_CONTROLLER = [
  {
    name: 'startDate',
    iconText: 'De',
  },
  {
    name: 'endDate',
    iconText: 'Até',
  },
]

const CREATE_PROJECT_SELECT_FIELDS_CONTROLLER = [
  {
    title: 'Responsável pelo projeto',
    icon: UserIcon,
    name: 'projectResponsible',
  },
  {
    title: 'Observadores',
    icon: EyeIcon,
    name: OBSERVER_ROLE,
  },
]

const RESPONSIBLE_FROM_AREAS_FIELDS_CONTROLLER = [
  {
    name: 'area',
    label: 'Área',
    placeholder: 'Selecione a área',
  },
  {
    name: 'responsible',
    label: 'Responsável',
    placeholder: 'Selecione o responsável',
  },
]

const TRANSLATED_PROJECT_ROLES = {
  [OBSERVER_ROLE]: 'Observador',
  [MANAGER_ROLE]: 'Gestor',
  [PROJECT_RESPONSIBLE_ROLE]: 'Responsável pelo projeto',
  [AREA_RESPONSIBLE_ROLE]: 'Responsável por área',
  [ACTIVITY_RESPONSIBLE_ROLE]: 'Responsável por atividade',
}

const QUESTION_RADIO_FIELDS_CONTROLLER = [
  {
    label: 'Sim',
    value: 'yes',
  },
  {
    label: 'Não',
    value: 'no',
  },
  {
    label: 'Parcial',
    value: 'partial',
  },
]

const CHOOSE_STATUS_INDEX_CARD_COLOR = {
  [OVERDUE_STATUS_ID]: colors.red[100],
  [COMPLETED_STATUS_ID]: colors.green[100],
  [ARCHIVED_STATUS_ID]: theme.palette.statusLabel.warning.secondary,
}

const CHOOSE_STATUS_INDEX_CARD_TEXT_COLOR = {
  [OVERDUE_STATUS_ID]: theme.palette.error.main,
  [COMPLETED_STATUS_ID]: theme.palette.success.main,
  [ARCHIVED_STATUS_ID]: theme.palette.statusLabel.warning.primary,
}

const SEGCOOP_QUEUE_STATUS_LABELS = {
  pending: 'Aguardando envio para o Segcoop',
  processing: 'Enviando para o Segcoop',
  completed: 'Enviado para o Segcoop',
  completed_partially: 'Enviado para o Segcoop',
}

const SEGCOOP_QUEUE_STATUS_TOOLTIP = {
  pending: 'O projeto está na fila para ser enviado para o Segcoop.',
  processing: 'O projeto está sendo enviado para o Segcoop.',
  completed: 'O projeto foi enviado para o Segcoop com sucesso.',
  completed_partially:
    'O projeto foi enviado para o Segcoop, mas houve algum problema com algumas informações. Verifique os detalhes do envio para mais informações.',
}

const SEGCOOP_DIALOG_TEXT = {
  pending: {
    title: 'Seu projeto já está na fila para ser enviado para o Segcoop',
    description:
      'O projeto está na fila para envio ao SEGCOOP. O início do envio pode levar até 15 minutos.',
  },
  processing: {
    title: 'Seu projeto está sendo enviado para o Segcoop',
    description:
      'O projeto está sendo enviado ao SEGCOOP. Esse processo pode levar algumas horas. Assim que o envio for concluído, você será avisado por e-mail.',
  },
  completed: {
    title: 'Seu projeto foi enviado para o Segcoop',
    description:
      'O projeto foi enviado com sucesso!. Para mais informações, baixe o relatório ou acesse diretamente o SEGCOOP.',
  },
  completed_partially: {
    title:
      'Seu projeto foi enviado para o Segcoop, mas ocorreram alguns problemas',
    description:
      'O projeto foi enviado, mas houve problema no preenchimento de alguns campos. Baixe o relatório para mais detalhes ou acesse o SEGCOOP para conferência.',
  },
}

const SEGCOOP_BUTTON_STATUS_COLORS = {
  pending: colors.blue[500],
  processing: colors.blueGrey[500],
  completed: colors.green[500],
  completed_partially: colors.yellow[700],
}

const SEGCOOP_STATUS_SEVERITY = {
  pending: 'info',
  processing: 'info',
  completed: 'success',
  completed_partially: 'warning',
}

const SEGCOOP_BUTTON_STATUS_ICON = {
  pending: ClockIcon,
  processing: ClockIcon,
  completed: CheckIcon,
  completed_partially: AlertTriangleIcon,
}

const SEGCOOP_BODY_STATUS_COLORS = {
  pending: colors.blue['A100'],
  processing: colors.blueGrey[500],
  completed: colors.green[900],
  completed_partially: colors.orange[500],
}

const IMPORT_STATUS_LABEL = {
  pending: 'Na fila de importação',
  importing_structure: 'Criando estrutura do projeto',
  importing_evidences: 'Importando evidências',
  importing_stages: 'Importando etapas de auditoria',
  completed: 'Importação concluída',
  completed_partially: 'Importação concluída com falhas',
  failed: 'Importação falhou',
}

const IMPORT_STATUS_DESCRIPTION = {
  pending: 'Seu projeto está na fila e será processado em breve.',
  importing_structure: 'A estrutura do projeto está sendo criada.',
  importing_evidences: 'As evidências estão sendo baixadas e importadas.',
  importing_stages: 'As etapas de auditoria estão sendo importadas.',
  completed: 'Importação finalizada com sucesso!',
  completed_partially:
    'A importação foi concluída, mas houve falhas em algumas atividades.',
  failed: 'Ocorreu um erro durante a importação do projeto.',
}

const IMPORT_STATUS_SEVERITY = {
  pending: 'info',
  importing_structure: 'info',
  importing_evidences: 'info',
  importing_stages: 'info',
  completed: 'success',
  completed_partially: 'warning',
  failed: 'error',
}

const IMPORT_TERMINAL_STATUSES = ['completed', 'completed_partially', 'failed']
const IMPORT_RETRYABLE_STATUSES = ['completed_partially', 'failed']
const IMPORT_IN_PROGRESS_STATUSES = [
  'pending',
  'importing_structure',
  'importing_evidences',
  'importing_stages',
]

const LINKABLE_STATUSES_IDS = [PENDING_STATUS_ID, OVERDUE_STATUS_ID]

export default {
  ACTIVITY_RESPONSIBLE_ROLE,
  AREA_RESPONSIBLE_ROLE,
  ARCHIVED_STATUS_ID,
  CHOOSE_STATUS_INDEX_CARD_COLOR,
  CHOOSE_STATUS_INDEX_CARD_TEXT_COLOR,
  COMPLETED_STATUS_ID,
  CREATE_PROJECT_DATE_FIELDS_CONTROLLER,
  CREATE_PROJECT_SELECT_FIELDS_CONTROLLER,
  EVIDENCE_FILE_MIMES_TYPES,
  EVIDENCE_FILE_TYPES,
  INACTIVE_STATUS_ID,
  LINKABLE_STATUSES_IDS,
  MANAGER_ROLE,
  NOT_APPLICABLE_VALUE,
  OBSERVER_ROLE,
  OVERDUE_STATUS_ID,
  PENDING_STATUS_ID,
  PLAN_ACTION_RESPONSIBLE_ROLE,
  PROJECT_RESPONSIBLE_ROLE,
  QUESTION_RADIO_FIELDS_CONTROLLER,
  RESPONSIBLE_FROM_AREAS_FIELDS_CONTROLLER,
  SEGCOOP_BODY_STATUS_COLORS,
  SEGCOOP_BUTTON_STATUS_COLORS,
  SEGCOOP_BUTTON_STATUS_ICON,
  SEGCOOP_DIALOG_TEXT,
  SEGCOOP_QUEUE_STATUS_LABELS,
  SEGCOOP_QUEUE_STATUS_TOOLTIP,
  SEGCOOP_STATUS_SEVERITY,
  SOFT_DELETED_STATUS_ID,
  TRANSLATED_PROJECT_ROLES,
  IMPORT_STATUS_LABEL,
  IMPORT_STATUS_DESCRIPTION,
  IMPORT_STATUS_SEVERITY,
  IMPORT_TERMINAL_STATUSES,
  IMPORT_RETRYABLE_STATUSES,
  IMPORT_IN_PROGRESS_STATUSES,
}
